export default __webpack_public_path__ + "static/cbd1-fab0cef85ba66a73f97e4bd27dbbbc94.png";